'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (WrappedComponent) {
  var reduxDraftEntity = function (_Component) {
    _inherits(reduxDraftEntity, _Component);

    function reduxDraftEntity() {
      _classCallCheck(this, reduxDraftEntity);

      var _this = _possibleConstructorReturn(this, (reduxDraftEntity.__proto__ || Object.getPrototypeOf(reduxDraftEntity)).call(this));

      _this.getData = _this._getData.bind(_this);
      return _this;
    }

    _createClass(reduxDraftEntity, [{
      key: '_getData',
      value: function _getData() {
        var _props = this.props,
            contentState = _props.contentState,
            entityKey = _props.entityKey;

        var entity = contentState.getEntity(entityKey);
        var data = entity.getData();

        return data;
      }
    }, {
      key: 'render',
      value: function render() {
        var _reduxDraft = this.context._reduxDraft;


        return _react2.default.createElement(WrappedComponent, _extends({
          getData: this.getData
        }, _reduxDraft, this.props));
      }
    }]);

    return reduxDraftEntity;
  }(_react.Component);

  reduxDraftEntity.contextTypes = {
    _reduxDraft: _propTypes2.default.object
  };

  return reduxDraftEntity;
};
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvcmVkdXhEcmFmdEVudGl0eS5qcyJdLCJuYW1lcyI6WyJXcmFwcGVkQ29tcG9uZW50IiwicmVkdXhEcmFmdEVudGl0eSIsImdldERhdGEiLCJfZ2V0RGF0YSIsImJpbmQiLCJwcm9wcyIsImNvbnRlbnRTdGF0ZSIsImVudGl0eUtleSIsImVudGl0eSIsImdldEVudGl0eSIsImRhdGEiLCJfcmVkdXhEcmFmdCIsImNvbnRleHQiLCJjb250ZXh0VHlwZXMiLCJvYmplY3QiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7Ozs7Ozs7Ozs7a0JBRWUsVUFBQ0EsZ0JBQUQsRUFBc0I7QUFBQSxNQUM3QkMsZ0JBRDZCO0FBQUE7O0FBRWpDLGdDQUFjO0FBQUE7O0FBQUE7O0FBRVosWUFBS0MsT0FBTCxHQUFlLE1BQUtDLFFBQUwsQ0FBY0MsSUFBZCxPQUFmO0FBRlk7QUFHYjs7QUFMZ0M7QUFBQTtBQUFBLGlDQU90QjtBQUFBLHFCQUN5QixLQUFLQyxLQUQ5QjtBQUFBLFlBQ0hDLFlBREcsVUFDSEEsWUFERztBQUFBLFlBQ1dDLFNBRFgsVUFDV0EsU0FEWDs7QUFFVCxZQUFJQyxTQUFTRixhQUFhRyxTQUFiLENBQXVCRixTQUF2QixDQUFiO0FBQ0EsWUFBSUcsT0FBT0YsT0FBT04sT0FBUCxFQUFYOztBQUVBLGVBQU9RLElBQVA7QUFDRDtBQWJnQztBQUFBO0FBQUEsK0JBZXhCO0FBQUEsWUFDREMsV0FEQyxHQUNlLEtBQUtDLE9BRHBCLENBQ0RELFdBREM7OztBQUdQLGVBQ0UsOEJBQUMsZ0JBQUQ7QUFDRSxtQkFBUyxLQUFLVDtBQURoQixXQUVNUyxXQUZOLEVBR00sS0FBS04sS0FIWCxFQURGO0FBT0Q7QUF6QmdDOztBQUFBO0FBQUE7O0FBNEJuQ0osbUJBQWlCWSxZQUFqQixHQUFnQztBQUM5QkYsaUJBQWEsb0JBQVVHO0FBRE8sR0FBaEM7O0FBSUEsU0FBT2IsZ0JBQVA7QUFDRCxDIiwiZmlsZSI6ImNvbXBvbmVudHMvcmVkdXhEcmFmdEVudGl0eS5qcyIsInNvdXJjZVJvb3QiOiJFOlxccHJvamVjdHNcXHJlZHV4LWRyYWZ0XFxzcmMifQ==



//////////////////
// WEBPACK FOOTER
// ../lib/components/reduxDraftEntity.js
// module id = 588
// module chunks = 0